<!-- F1120 Schedule M3 Component - EXACT Migration from AngularJS -->

<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  
  <!-- Entity Information Table -->
  <table class="table table-bordered form-inline enityDetails custom-table">
    <tr>
      @for (item of entityList; track $index) {
<td>
        <span>{{ item.key }}</span>
      </td>
}
    </tr>
    <tr>
      @for (item of entityList; track $index) {
<td>
        <span>{{ item.value }}</span>
      </td>
}
    </tr>
  </table>
  
  <!-- Form Loader -->
    @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}
    
  @if (!showFormLoader) {
<div class="row">
    
    <!-- Partnership Name and EIN Table -->
    <table class="table table-bordered form-inline">
            <tr>
              <td>Name of partnership
                <div>
            <input class="form-control input-md numText text_field_width"
                    type="text"
                   [value]="scheduleM3FormView.rows[0]?.value || ''"
                   (input)="updateValue(0, $event, 'value')" 
                   [disabled]="true">
                </div>
              </td>
              <td>Employer identification number
                <div>
            <input class="form-control input-md numText text_field_width"
                    type="text"
                    maxlength="10"
                   [value]="scheduleM3FormView.rows[0]?.value_user_input || ''"
                   (input)="updateValue(0, $event, 'value_user_input')" 
                   [disabled]="true">
                </div>
              </td>
            </tr>
          </table>

    <!-- Section A-E: Single Checkboxes -->
    <table class="ScheduleM3Block table table-bordered form-inline">
              <tbody>
        @for (row of scheduleM3FormView.rows; track $index; let i = $index) {
<tr
            [hidden]="!(row.num === 'A' || row.num === 'B' || row.num === 'C' || row.num === 'D' || row.num === 'E')">
                  <td>{{row.num}}</td>
                  <td class="descBlock">
            <span>
              <input type="checkbox" 
                     [checked]="row.value === true"
                     [name]="row.num" 
                     (change)="onCheckboxChange(i, $event, 'single')"/>
            </span>
                    <span>{{row.description}}</span>
                    
            <!-- Partner Data Sub-table for line D -->
            @if (row.num === 'D' && scheduleM3FormView.rows[5]?.value === true) {
<div>
              <table class="subTable">
                <tr>
                  <th>(i) Name of Reportable Entity Partner</th>
                  <th>(ii) Identifying Number</th>
                  <th>(iii) Maximum Percentage Owned or Deemed Owned</th>
                          <th class="addRowsColumn">
                            <i class="fa fa-plus-circle color-green" (click)="addPartnerRow()"></i>
                          </th>
                        </tr>
                        @for (partner of row.JSON_DATA; track $index; let idx = $index) {
<tr>
                          <td>
                    <input type="text" 
                           maxlength="67" 
                           [(ngModel)]="partner.DATA_ATTRIB_A" 
                           class="form-control input-sm">
                          </td>
                          <td>
                    <input type="text" 
                           maxlength="10" 
                           [(ngModel)]="partner.DATA_ATTRIB_B" 
                           class="form-control input-sm">
                          </td>
                          <td>
                    <input type="number" 
                           class="form-control input-sm" 
                           [(ngModel)]="partner.DATA_ATTRIB_C" 
                           min="1" 
                              max="100">
                          </td>
                          <td style="text-align: center;">
                            <i class="fa fa-minus-circle color-red" (click)="removePartnerRow(idx)"></i>
                          </td>
                        </tr>
}
                      </table>
              @if (!row.JSON_DATA || row.JSON_DATA.length === 0) {
<div class="noRecordsBlock">
                        <span>No Records</span>
                      </div>
}
                    </div>
}
                  </td>
                </tr>
}
              </tbody>
            </table>

    <!-- Main Schedule M3 Table -->
    <table class="ScheduleM3Block table table-bordered form-inline">
              <thead>
                <tr>
                  <th colspan="10">{{modalTitle}}</th>
                </tr>
              </thead>
              <tbody>
                
        <!-- Row 1: Yes/No Checkboxes -->
        <tr>
          <td>{{scheduleM3FormView.rows[6]?.num}}</td>
          <td class="descBlock">
            <span>{{scheduleM3FormView.rows[6]?.description}}</span>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[6]?.num" 
                     [checked]="scheduleM3FormView.rows[6]?.value === true"
                     (change)="onSingleCheckboxChange(6, true, $event)"/>
              <b></b> {{scheduleM3FormView.rows[7]?.description}}
            </div>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[6]?.num + '_no'" 
                     [checked]="scheduleM3FormView.rows[6]?.value === false"
                     (change)="onSingleCheckboxChange(6, false, $event)"/>
              <b></b> {{scheduleM3FormView.rows[8]?.description}}
            </div>
          </td>
        </tr>

        <!-- Row 2: Yes/No Checkboxes -->
        <tr>
          <td>{{scheduleM3FormView.rows[9]?.num}}</td>
          <td class="descBlock">
            <span>{{scheduleM3FormView.rows[9]?.description}}</span>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[9]?.num" 
                     [checked]="scheduleM3FormView.rows[9]?.value === true"
                     (change)="onSingleCheckboxChange(9, true, $event)"/>
              <b></b> {{scheduleM3FormView.rows[10]?.description}}
            </div>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[9]?.num + '_no'" 
                     [checked]="scheduleM3FormView.rows[9]?.value === false"
                     (change)="onSingleCheckboxChange(9, false, $event)"/>
              <b></b> {{scheduleM3FormView.rows[11]?.description}}
            </div>
          </td>
        </tr>

        <!-- Row 3: Yes/No Checkboxes -->
        <tr>
          <td>{{scheduleM3FormView.rows[12]?.num}}</td>
                  <td class="descBlock">
            <span>{{scheduleM3FormView.rows[12]?.description}}</span>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[12]?.num" 
                     [checked]="scheduleM3FormView.rows[12]?.value === true"
                     (change)="onSingleCheckboxChange(12, true, $event)"/>
              <b></b>{{scheduleM3FormView.rows[13]?.description}}
            </div>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[12]?.num + '_no'" 
                     [checked]="scheduleM3FormView.rows[12]?.value === false"
                     (change)="onSingleCheckboxChange(12, false, $event)"/>
              <b></b> {{scheduleM3FormView.rows[14]?.description}}
            </div>
          </td>
        </tr>

        <!-- Row 2: Date Pickers -->
        <tr>
          <td>{{scheduleM3FormView.rows[15]?.num}}</td>
          <td class="descBlock">
            <span>{{scheduleM3FormView.rows[15]?.description}}</span>
            <span>{{scheduleM3FormView.rows[16]?.description}}:</span>
            <span class="input-group">
              <input type="date" 
                     class="form-control input-sm" 
                     [value]="getFormattedDateValue(16)"
                     (input)="updateDateValue(16, $event)">
                 </span>
            <span>{{scheduleM3FormView.rows[17]?.description}}:</span>
            <span class="input-group">
                            <input type="date" 
                        class="form-control input-sm" 
                     [value]="getFormattedDateValue(17)"
                     (input)="updateDateValue(17, $event)">
                </span>
          </td>
        </tr>

        <!-- Row 3: Yes/No Checkboxes -->
        <tr>
          <td>{{scheduleM3FormView.rows[18]?.num}}</td>
          <td class="descBlock">
            <span>{{scheduleM3FormView.rows[18]?.description}}</span>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[18]?.num" 
                     [checked]="scheduleM3FormView.rows[18]?.value === true"
                     (change)="onSingleCheckboxChange(18, true, $event)"/>
              <b></b> {{scheduleM3FormView.rows[19]?.description}}
            </div>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[18]?.num + '_no'" 
                     [checked]="scheduleM3FormView.rows[18]?.value === false"
                     (change)="onSingleCheckboxChange(18, false, $event)"/>
              <b></b> {{scheduleM3FormView.rows[20]?.description}}
                    </div>
          </td>
        </tr>

        <!-- Row 4: Yes/No Checkboxes -->
        <tr>
          <td>{{scheduleM3FormView.rows[21]?.num}}</td>
          <td class="descBlock">
            <span>{{scheduleM3FormView.rows[21]?.description}}</span>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[21]?.num" 
                     [checked]="scheduleM3FormView.rows[21]?.value === true"
                     (change)="onSingleCheckboxChange(21, true, $event)"/>
              <b></b> {{scheduleM3FormView.rows[22]?.description}}
            </div>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[21]?.num + '_no'" 
                     [checked]="scheduleM3FormView.rows[21]?.value === false"
                     (change)="onSingleCheckboxChange(21, false, $event)"/>
              <b>{{scheduleM3FormView.rows[23]?.description}}. </b>
                      </div>
          </td>
        </tr>

        <!-- Row 5: Yes/No Checkboxes -->
        <tr>
          <td>{{scheduleM3FormView.rows[24]?.num}}</td>
          <td class="descBlock">
            <span>{{scheduleM3FormView.rows[24]?.description}}</span>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[24]?.num" 
                     [checked]="scheduleM3FormView.rows[24]?.value === true"
                     (change)="onSingleCheckboxChange(24, true, $event)"/>
              <b></b> {{scheduleM3FormView.rows[25]?.description}}
                      </div>
            <div>
              <input type="checkbox" 
                     [name]="scheduleM3FormView.rows[24]?.num + '_no'" 
                     [checked]="scheduleM3FormView.rows[24]?.value === false"
                     (change)="onSingleCheckboxChange(24, false, $event)"/>
              <b></b> {{scheduleM3FormView.rows[26]?.description}}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

        <!-- Additional Rows Table (indices 27-49) -->
    <table class="ScheduleM3Block table table-bordered form-inline">
      <tbody>
        @for (row of scheduleM3FormView.rows; track $index; let i = $index) {
<tr
            [hidden]="!(i > 26 && i < 50)">
          <td style="width: 58px">{{row.num}}</td>
          <td class="descBlock">
            @if (row.num === '4b1' || row.num === '4b2' || row.num === '4b3' || row.num === '4b4' || row.num === '4b5') {
<span>
              <input type="checkbox" 
                     [checked]="row.value === true" 
                     [name]="row.num" 
                     (change)="onCheckboxChange(i, $event, 'single')"/>
            </span>
}
            <span>{{row.description}}</span>
            @if (row.num === '4b5') {
<input type="text" 
                   [disabled]="row.conditionalField" 
                   [value]="row.value_user_input || ''"
                   (input)="updateValueField(i, $event, 'value_user_input')" 
                   [name]="row.num" 
                   
                   class="form-control input-sm">
}

            <!-- Sub-table for row 12 with 4 rows -->
            @if (row.num === '12') {
<table class="subTable" style="margin-top: 6px;">
              <thead>
                <tr>
                  <th style="width:186px;padding: 0 !important;background-color: hsla(0, 0%, 0%, 0) !important;border: none;"></th>
                  <th>Total Assets</th>
                  <th>Total Liabilities</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="border: none;"><b style="float: left;">a </b>{{scheduleM3FormView.rows[50]?.description}}</td>
                  <td>
                    <input class="form-control input-md numText currency" 
                           type="text" 
                           [value]="formatNumber(scheduleM3FormView.rows[50]?.value) || ''"
                           (input)="updateNumberField(50, $event, 'value')"
                           placeholder="0">
                  </td>
                  <td>
                    <input class="form-control input-md numText currency" 
                           type="text" 
                           [value]="formatNumber(scheduleM3FormView.rows[50]?.value_user_input) || ''"
                           (input)="updateNumberField(50, $event, 'value_user_input')"
                           placeholder="0">
                  </td>
                </tr>
                <tr>
                  <td style="border: none;"><b style="float: left;">b </b>{{scheduleM3FormView.rows[51]?.description}}</td>
                  <td>
                    <input class="form-control input-md numText currency" 
                           type="text" 
                           [value]="formatNumber(scheduleM3FormView.rows[51]?.value) || ''"
                           (input)="updateNumberField(51, $event, 'value')"
                           placeholder="0">
                  </td>
                  <td>
                    <input class="form-control input-md numText currency" 
                           type="text" 
                           [value]="formatNumber(scheduleM3FormView.rows[51]?.value_user_input) || ''"
                           (input)="updateNumberField(51, $event, 'value_user_input')"
                           placeholder="0">
                  </td>
                </tr>
                <tr>
                  <td style="border: none;"><b style="float: left;">c </b>{{scheduleM3FormView.rows[52]?.description}}</td>
                  <td>
                    <input class="form-control input-md numText currency" 
                           type="text" 
                           [value]="formatNumber(scheduleM3FormView.rows[52]?.value) || ''"
                           (input)="updateNumberField(52, $event, 'value')"
                           placeholder="0">
                  </td>
                  <td>
                    <input class="form-control input-md numText currency" 
                           type="text" 
                           [value]="formatNumber(scheduleM3FormView.rows[52]?.value_user_input) || ''"
                           (input)="updateNumberField(52, $event, 'value_user_input')"
                           placeholder="0">
                  </td>
                </tr>
                <tr>
                  <td style="border: none;"><b style="float: left;">d </b>{{scheduleM3FormView.rows[53]?.description}}</td>
                  <td>
                    <input class="form-control input-md numText currency" 
                           type="text" 
                           [value]="formatNumber(scheduleM3FormView.rows[53]?.value) || ''"
                           (input)="updateNumberField(53, $event, 'value')"
                           placeholder="0">
                  </td>
                  <td>
                    <input class="form-control input-md numText currency" 
                           type="text" 
                           [value]="formatNumber(scheduleM3FormView.rows[53]?.value_user_input) || ''"
                           (input)="updateNumberField(53, $event, 'value_user_input')"
                           placeholder="0">
                  </td>
                </tr>
              </tbody>
            </table>
}
          </td>
          
          <!-- Right column for numeric inputs (fields 3b-11) -->
          @if (shouldShowRightColumn(row)) {
<td style="width: 170px" align="right" 
             >
            <div [hidden]="isSpecialRow(row.num)">
              <!-- Numeric inputs for specific rows -->
              @if (isNumericInputRow(row.num)) {
<input class="form-control input-md numText currency" 
                     type="text"
                    
                     style="text-align: right"
                     [value]="formatNumber(row.value) || ''"
                     (input)="updateNumberField(i, $event, 'value')"
                     (change)="computeValues()"
                     placeholder="0">
}
              
              <!-- Text inputs for 3b, 3c -->
              @if (row.num === '3b' || row.num === '3c') {
<input class="form-control input-md" 
                     type="text"
                    
                     [value]="row.value || ''"
                     (input)="updateValue(i, $event, 'value')"
                     (change)="computeValues()">
}
          </div>
          </td>
}
        </tr>
}
      </tbody>
    </table>

  </div>
}
</div>

<!-- Footer for modal -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>